// src/left-menu/index.js
import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
    Sidebar,
    SidebarHeader,
    SidebarBody,
    SidebarFooter,
} from "../../catalyst/sidebar";
import {
    Dialog,
    DialogTitle,
    DialogActions,
    DialogBackdrop, DialogPanel,
    Field
} from "@headlessui/react";
import { HomeIcon } from "@heroicons/react/24/outline";

import { Auth } from "aws-amplify";

import { useSelector, useDispatch } from 'react-redux';
import { setLeftMenuWidth, setSurveys, setUserSurveys, setOrganizations, updateTabPath, updateTabStates } from '../../store/actions';

import LeftMenuCollect from "./collect";
import LeftMenuDesign from "./design";
import LeftMenuResults from "./results";
import LeftMenuSurveys from "./surveys";
import LeftMenuInsight from "./insight";

import { getNotificationsFromAPI, readNotificationFromAPI } from "../../services/notificationService";
import { getSurveysFromAPI, addSurveyFromAPI } from "../../services/surveyService";

const LeftMenu = () => {

    const themeMode = useSelector(state => state.themeMode);
    // const leftMenuContent = useSelector(state => state.leftMenuContent);
    // const leftMenuVisibility = useSelector(state => state.leftMenuVisibility);
    const topMenuTabs = useSelector(state => state.topMenuTabs);

    // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
    const leftMenuContent = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.leftMenuContent;
    const leftMenuVisibility = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.leftMenuVisibility;
    const leftMenuExpanded = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.leftMenuExpanded;
    const location = useLocation();
    const dispatch = useDispatch();

    const activeTabRef = useRef(topMenuTabs.activeTab);

    useEffect(() => {
        activeTabRef.current = topMenuTabs.activeTab; // Güncellenmiş değeri sakla
    }, [topMenuTabs.activeTab]);

    const defaultDemographicsPage = {
        "name": "Demographics",
        "title": "DEMOGRAPHICS",
        "type": "demographics",
        "elements": [
            {
                "name": "Demographics",
                "type": "panel",
                "elements": [
                    {
                        "name": "Demographics",
                        "type": "html",
                        "html": "<h5>Demographics</h5>"
                    },
                    {
                        "name": "Demographics",
                        "type": "panel",
                        "elements": [
                            {
                                "name": "",
                                "isRequired": true,
                                "choices": [
                                    {
                                        "value": 1,
                                        "text": "Financial Services"
                                    },
                                    {
                                        "value": 2,
                                        "text": "Insurance"
                                    },
                                    {
                                        "value": 3,
                                        "text": "Consulting"
                                    },
                                    {
                                        "value": 4,
                                        "text": "Software/Internet"
                                    },
                                    {
                                        "value": 5,
                                        "text": "Telecommunications"
                                    },
                                    {
                                        "value": 6,
                                        "text": "Manufacturing (non-computers)"
                                    },
                                    {
                                        "value": 7,
                                        "text": "Manufacturing (computers)"
                                    },
                                    {
                                        "value": 8,
                                        "text": "Retail/Wholesale"
                                    },
                                    {
                                        "value": 9,
                                        "text": "Government"
                                    },
                                    {
                                        "value": 10,
                                        "text": "Education"
                                    },
                                    {
                                        "value": 11,
                                        "text": "Pharmaceuticals"
                                    },
                                    {
                                        "value": 12,
                                        "text": "Media/Advertising"
                                    },
                                    {
                                        "value": 13,
                                        "text": "Utilities"
                                    },
                                    {
                                        "value": 14,
                                        "text": "Hospitality/Travel"
                                    },
                                    {
                                        "value": 15,
                                        "text": "Transportation"
                                    },
                                    {
                                        "value": 16,
                                        "text": "Food/Beverage"
                                    },
                                    {
                                        "value": 17,
                                        "text": "Online retail"
                                    },
                                    {
                                        "value": 18,
                                        "text": "Other"
                                    },
                                    {
                                        "value": 19,
                                        "text": "Healthcare"
                                    }
                                ],
                                "title": " Which best describes your industry?",
                                "type": "dropdown"
                            }
                        ]
                    },
                    {
                        "name": "Demographics",
                        "type": "panel",
                        "elements": [
                            {
                                "name": "",
                                "isRequired": true,
                                "choices": [
                                    {
                                        "value": 1,
                                        "text": "Less than $10M"
                                    },
                                    {
                                        "value": 2,
                                        "text": "$10-$49M"
                                    },
                                    {
                                        "value": 3,
                                        "text": "$50M-$99M"
                                    },
                                    {
                                        "value": 4,
                                        "text": "$100M-$499M"
                                    },
                                    {
                                        "value": 5,
                                        "text": "$500M-$999M"
                                    },
                                    {
                                        "value": 6,
                                        "text": "$1B-$4.9B"
                                    },
                                    {
                                        "value": 7,
                                        "text": "$5B-$9.9B"
                                    },
                                    {
                                        "value": 8,
                                        "text": "Greater than $10B"
                                    },
                                    {
                                        "value": 9,
                                        "text": "Don't know"
                                    }
                                ],
                                "title": " What size is your company?",
                                "type": "dropdown"
                            }
                        ]
                    }
                ]
            }
        ]
    };

    useEffect(() => {
        const urlSegments = window.location.pathname.split("/");
        const lastSegment = urlSegments[urlSegments.length - 1];
        if (lastSegment === "q-robot" || lastSegment === "create-from-file" || lastSegment === "" || lastSegment === "home" || lastSegment === "benchmarked" || lastSegment === "summary") {
            dispatch(updateTabStates(topMenuTabs.activeTab, 'leftMenuContent', 'Surveys'));
        }else if( urlSegments.includes("help")){
                dispatch(updateTabStates(topMenuTabs.activeTab, 'leftMenuExpanded', false));
        }else {
            const formattedSegment = lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1);
            if (formattedSegment.startsWith("Collect-")) {
                dispatch(updateTabStates(topMenuTabs.activeTab, 'leftMenuContent', "Collect"));
            } else if (formattedSegment.startsWith("Insight-")) {
                dispatch(updateTabStates(topMenuTabs.activeTab, 'leftMenuContent', "Insight"));
            }
            // else if (formattedSegment.startsWith("Roadmap")) {
            //     dispatch(updateTabStates(topMenuTabs.activeTab, 'leftMenuContent', "Insight"));
            // }


        }
    }, [location.pathname]);
    let [token, setToken] = useState("");
    const [attributes, setAttributes] = useState({});
    const [width, setWidth] = useState(350); // Başlangıç genişliği
    const [isResizing, setIsResizing] = useState(false);
    const [menuVisibilityState, setMenuVisibilityState] = useState("Show Menu");
    // const [expanded, setExpanded] = useState(true); // Menü genişletme durumu
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [notificationDropdownOpen, setNotificationDropdownOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [homeContent, setHomeContent] = useState(false);
    const signoutModalRef = useRef(null);
    const notificationModalRef = useRef(null);
    const [user, setUser] = useState({
        name: '',
        family_name: '',
        email: ''
    });
    const [newSurveyDialog, setNewSurveyDialog] = useState(false);
    const [newSurveyName, setNewSurveyName] = useState("");
    const [selectedFunction, setSelectedFunction] = useState("");
    const [selectedFunctionParam, setSelectedFunctionParam] = useState("");

    const handleClickOutside = (event, ref, setState) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setState(false) // Eğer dışarıya tıklanırsa, ilgili modalı kapat
        }
    };
    useEffect(() => {
        if (dropdownOpen) {
            document.addEventListener('click', (event) => handleClickOutside(event, signoutModalRef, setDropdownOpen));
        }

        if (notificationDropdownOpen) {
            document.addEventListener('click', (event) => handleClickOutside(event, notificationModalRef, setNotificationDropdownOpen));
        }

        return () => {
            document.removeEventListener('click', (event) => handleClickOutside(event, signoutModalRef, setDropdownOpen));
            document.removeEventListener('click', (event) => handleClickOutside(event, notificationModalRef, setNotificationDropdownOpen));
        };
    }, [dropdownOpen, notificationDropdownOpen]);
    let section = "";

    const navigate = useNavigate();
    const [visibleTooltip, setVisibleTooltip] = useState({});
    const [notifications, setNotifications] = useState([]);

    async function checkAuth() {
        // window.location.reload();
        try {
            const cognitoUser = await Auth.currentAuthenticatedUser();
            const currentSession = await Auth.currentSession();
            await cognitoUser.refreshSession(
                currentSession.refreshToken,
                (err, session) => {
                    const { idToken, refreshToken, accessToken } = session;
                    getToken(idToken.jwtToken);
                }
            );
        } catch (e) {
            // console.log('Unable to refresh Token', e);
        }
    }

  async function getToken(token) {

      const currentSession = await Auth.currentSession();
      setToken(currentSession.idToken.jwtToken);
    
  }
    useEffect(() => {
        if (token.length > 0) {
            if (selectedFunction === "markAsRead") {
                markAsRead(selectedFunctionParam);
            } else if (selectedFunction === "markAllAsRead") {
                markAllAsRead();
            } else if (selectedFunction === "getSurveys") {
                getSurveys(selectedFunctionParam);
            } else if (selectedFunction === "createNewSurvey") {
                createNewSurvey();
            } else {
                getNotifications();
            }
            setSelectedFunction("");
            setSelectedFunctionParam("");
        }
    }, [token]);

    const getNotifications = async () => {
        try {
            await getNotificationsFromAPI(token, attributes["custom:org_name"]).then(
                (response) => {
                    let sortedData = response["notifications"].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
                    sortedData.forEach((notification) => {
                        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
                        notification.created_at = new Date(notification.created_at).toLocaleString("en-US", { timeZone: tz });
                        notification.time = formatRelativeTime(notification.created_at);
                    });
                    setNotifications(sortedData);
                }
            ).catch((error) => {
                if (error.message === "Request failed with status code 401") {
                    checkAuth();
                }
            });
        } catch (error) {
        }
    }

    async function markAsRead(id) {
        try {
            setNotifications(notifications.map((notification) => {
                if (notification.id === id) {
                    notification.is_read = true;
                }
                return notification;
            }));
            await readNotificationFromAPI(token, attributes["custom:org_name"], id).then((response) => {
            }).catch((error) => {
                setNotifications(notifications.map((notification) => {
                    if (notification.id === id) {
                        notification.is_read = false;
                    }
                    return notification;
                }));
                if (error.message === "Request failed with status code 401") {
                    setSelectedFunction("markAsRead");
                    setSelectedFunctionParam(id);
                    checkAuth();
                }
            });
        }
        catch (error) {
        }
    }

    async function markAllAsRead() {
        try {
            setNotifications(notifications.map((notification) => {
                notification.is_read = true;
                return notification;
            }));
            await readNotificationFromAPI(token, attributes["custom:org_name"], "all").then((response) => {
            }).catch((error) => {
                setNotifications(notifications.map((notification) => {
                    notification.is_read = false;
                    return notification;
                }));
                if (error.message === "Request failed with status code 401") {
                    setSelectedFunction("markAllAsRead");
                    checkAuth();
                }
            });
        }
        catch (error) {

        }
    }

    function formatRelativeTime(date) {
        const now = new Date();
        const givenDate = new Date(date);
        const diffMs = now - givenDate; // Zaman farkı milisaniye olarak
        const diffSeconds = Math.floor(diffMs / 1000);
        const diffMinutes = Math.floor(diffSeconds / 60);
        const diffHours = Math.floor(diffMinutes / 60);
        const diffDays = Math.floor(diffHours / 24);
        const diffMonths = Math.floor(diffDays / 30);
        const diffYears = Math.floor(diffDays / 365);

        if (diffSeconds < 60) return `${diffSeconds} seconds ago`;
        if (diffMinutes < 60) return `${diffMinutes} minutes ago`;
        if (diffHours < 24) return `${diffHours} hours ago`;
        if (diffDays < 30) return `${diffDays} days ago`;
        if (diffMonths < 12) return `${diffMonths} months ago`;
        return `${diffYears} years ago`;
    }

    function classNames(...classes) {
        return classes.filter(Boolean).join(" ");
    }

    const handleMouseEnter = (id) => {
        setVisibleTooltip((prev) => ({ ...prev, [id]: true }));
    };

    const handleMouseLeave = (id) => {
        setVisibleTooltip((prev) => ({ ...prev, [id]: false }));
    };

    const menuRef = useRef(null);

    const handleMouseMove = (e) => {
        if (isResizing) {
            const maxWidth = window.innerWidth * 0.33; // Menü genişliği, ekran genişliğinin %33'ü kadar olacak
            const newWidth = Math.min(Math.max(e.clientX, 300), maxWidth); // Fare x pozisyonu 70px ile maxWidth arasında olacak
            setWidth(newWidth);
        }
    };

    // const handleLeftMenuContent = () => {
    //     setHomeContent((prevState) => !prevState); // Önceki değerin tersini al
    // };


    useEffect(() => {
        Auth.currentAuthenticatedUser()
            .then((user) => {
                setUser({
                    name: user.attributes['name'],
                    family_name: user.attributes['family_name'],
                    email: user.attributes['email']
                });
                setAttributes(user.attributes);
                // Örnek: attributes.email, attributes.phone_number gibi
            })
            .catch();
        getToken();

        const interval = setInterval(() => {
            // getNotifications();
        }, 25000); //

        return () => clearInterval(interval); // Bileşen unmount olduğunda interval'ı temizle
    }, []);

    // ResizeObserver'ı kullanarak LeftMenu'nun genişliğini dinleyelim
    useEffect(() => {
        const resizeObserver = new ResizeObserver(() => {
            // Sol menü genişliği değiştiğinde güncelle
            if (menuRef.current) {
                const newWidth = menuRef.current.offsetWidth;
                // dispatch(setLeftMenuWidth(newWidth + 68)); // Redux state'i güncelle
                dispatch(updateTabStates(activeTabRef.current, 'leftMenuWidth', newWidth + 68));
            }
        });

        if (menuRef.current) {
            resizeObserver.observe(menuRef.current); // Sol menüyü gözlemlemeye başla
        }

        // Temizleme işlemi (component unmount olduğunda)
        return () => {
            if (menuRef.current) {
                resizeObserver.unobserve(menuRef.current);
            }
        };
    }, []);

    const handleToggleWidth = (e) => {
        const urlSegments = window.location.pathname.split("/");
        if (!urlSegments.includes("help")){
        setMenuVisibilityState(leftMenuExpanded ? "Show Menu" : "Hide Menu");
        dispatch(updateTabStates(topMenuTabs.activeTab, 'leftMenuExpanded', !leftMenuExpanded));
        if (isResizing) {
            setWidth(window.innerWidth * 0.33);
        }
        }
    };

    // Sürükleme işlemini başlatma
    const handleMouseDown = () => {
        setIsResizing(true);
    };

    // Sürükleme işlemini durdurma
    const handleMouseUp = () => {
        setIsResizing(false);
    };
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 1024) {
                // setExpanded(false); // sm ekranlarda expanded state'i kapat
                dispatch(updateTabStates(topMenuTabs.activeTab, 'leftMenuExpanded', false));
                if (window.innerWidth < 640) {
                    const newWidth = menuRef.current.offsetWidth;
                    // dispatch(setLeftMenuWidth(newWidth + 55));
                    dispatch(updateTabStates(activeTabRef.current, 'leftMenuWidth', newWidth + 55));
                }
            }
        };

        // İlk kontrol ve dinleyici ekleme
        handleResize();
        window.addEventListener("resize", handleResize);

        // Cleanup listener
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const toggleDropdown = (event) => {
        event.stopPropagation();  // Tıklama olayının başka yerlere yayılmasını engelle
        setDropdownOpen((prev) => !prev);
        if (notificationDropdownOpen) {
            setNotificationDropdownOpen(false); // Notifications modalı açıkken dropdown açılmamalı
        }
    };

    // Notification Dropdown'ı açıp kapatma fonksiyonu
    const toggleNotificationDropdown = (event) => {
        event.stopPropagation();  // Tıklama olayının başka yerlere yayılmasını engelle
        setNotificationDropdownOpen((prev) => !prev);

        setDropdownOpen(false); // Dropdown açıkken notifications modalı açılmamalı

    };

    // Sayfa genelinde fare hareketlerini dinlemek için event ekliyoruz
    React.useEffect(() => {
        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
        return () => {
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
        };
    }, [isResizing]);

    const directionPage = (page) => {
        if (window.innerWidth < 1024 && leftMenuExpanded) {
            handleToggleWidth()

        }
        if (page === "create-from-file") {
            // dispatch(setHomeSelectedTab("Create From File"));
            dispatch(updateTabStates(topMenuTabs.activeTab, 'homeSelectedTab', 'Create From File'));
            dispatch(updateTabPath(topMenuTabs.activeTab, 'Create From File', `/home/create-from-file`));
        } else if (page === "q-robot") {
            // dispatch(setHomeSelectedTab("Q - Robot"));
            dispatch(updateTabStates(topMenuTabs.activeTab, 'homeSelectedTab', 'Q - Robot'));
            dispatch(updateTabPath(topMenuTabs.activeTab, 'Q - Robot', `/home/q-robot`));
        } else if (page === "benchmarked") {
            // dispatch(setHomeSelectedTab("Benchmarked"));
            dispatch(updateTabStates(topMenuTabs.activeTab, 'homeSelectedTab', 'Benchmarked'));
            dispatch(updateTabPath(topMenuTabs.activeTab, 'Benchmarked', `/home/benchmarked`));
        }
        navigate(`/home/${page}`);
    }

    async function getSurveys(new_survey_id) {
        dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', true));
        try {
            const result = await getSurveysFromAPI(token);

            result["surveys"].forEach((survey) => {
                survey["responded"] = result["userSurveyItems"].filter(
                    (item) => item.survey_id === survey.ID && item.is_completed).length + "/"
                    + result["userSurveyItems"].filter((item) => item.survey_id === survey.ID).length + " Responded";
            });
            dispatch(setSurveys(result["surveys"].sort((a, b) => new Date(b.created_at) - new Date(a.created_at))));
            dispatch(setUserSurveys(result["userSurveyItems"]));
            dispatch(setOrganizations(result["organizations"]));
            if (new_survey_id) {
                dispatch(updateTabStates(topMenuTabs.activeTab, 'currentSurvey', result["surveys"].find(survey => survey.ID === new_survey_id)));
                dispatch(updateTabStates(topMenuTabs.activeTab, 'surveyDetailSelectedTab', "Summary"));
                dispatch(updateTabPath(topMenuTabs.activeTab, 'Summary', `/surveys/${new_survey_id}/summary`));
                navigate(`/surveys/${new_survey_id}/summary`);
            }
            
        } catch (error) {
            if (error?.message === "Request failed with status code 401") {
                setSelectedFunction("getSurveys");
                setSelectedFunctionParam(new_survey_id);
                checkAuth();
            }
        } finally {
            dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', false));
        }
    }

    const openNewSurveyDialog = () => {
        setNewSurveyName("");
        setNewSurveyDialog(true);
    };

    async function createNewSurvey() {
        dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', true));
        setNewSurveyDialog(false);
        try {
            const userCognitoInfo = await Auth.currentUserInfo();
            const obj = {
                survey_name: newSurveyName,
                organization: userCognitoInfo.attributes["custom:org_name"],
                content: {
                    firstPageIsStarted: false,
                    progressBarShowPageNumbers: true,
                    progressBarShowPageTitles: true,
                    progressBarType: "pages",
                    questionsOnPageMode: "standard",
                    showPageTitles: false,
                    showProgressBar: "top",
                    showQuestionNumbers: "on",
                    startSurveyText: "Start Survey",
                    width: "1500",
                    widthMode: "static",
                    pages: [defaultDemographicsPage],
                },
            };
            await addSurveyFromAPI(token, obj)
                .then(async (result) => {
                    getSurveys(result.survey_id);
                })
                .catch((error) => {
                    if (error?.message === "Request failed with status code 401") {
                        setSelectedFunction("createNewSurvey");
                        checkAuth();
                    }
                });
        } catch (error) {

        }
    }

    const [logOutAllowMenuOpen, setLogOutAllowMenuOpen] = useState(false)

    const handleLogout = async () => {
        try {
            await Auth.signOut();
            setLogOutAllowMenuOpen(false)
            // İsterseniz çıkış sonrası yönlendirme yapabilirsiniz
        } catch (error) {
            setLogOutAllowMenuOpen(false)
        }
    };
    const getLeftMenuExpandActionFromChild = (data) => {
        dispatch(updateTabStates(topMenuTabs.activeTab, 'leftMenuExpanded', data)) // Child'dan gelen veriyi al
    };
    return (
        <>
            <div className={`flex fixed  left-0 h-full ${leftMenuVisibility === "show" ? "block" : "hidden"}`}>
                <Sidebar
                    className={`border-r w-[3.5rem] sm:w-[4.25rem]  ${themeMode === "dark" ? "border-white-opacity-10" : ""
                        } `}
                >
                    <SidebarHeader
                        className={`border-b-0 ${themeMode === "dark" ? "bg-[#14141f]" : "bg-[#fbfbfc]"
                            }`}
                    >
                        <ul>
                            <li
                                className="cursor-pointer  z-10" id="leftMenuToggle"
                                onMouseEnter={() => handleMouseEnter(1)} // Tooltip görünür yapılıyor
                                onMouseLeave={() => handleMouseLeave(1)}
                            >
                                <div
                                    className={`mb-4 group  flex justify-center rounded  text-[#7F7F7F] hover:font-normal ${themeMode === "dark"
                                        ? " hover:text-[rgba(255,_255,_255,_0.8)]"
                                        : " hover:text-black "
                                        }`}
                                    onClick={handleToggleWidth}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        className="size-5 opacity-75"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M3.75 9h16.5m-16.5 6.75h16.5"
                                        />
                                    </svg>
                                    {visibleTooltip[1] && (
                                        <div className={`tooltip absolute right z-[10000] flex justify-center w-[6.2rem] top-[12px] left-[calc(32px+0.75rem)] transform -translate-y-1/2 p-2 text-center text-xs ${themeMode === "dark" ? "text-[#FFF] bg-theme-tooltip-bg" : "text-black bg-[#efeff2]"}  border border-theme-popup-divider rounded shadow-theme-popup-shadow select-none flex items-center`}>
                                            {menuVisibilityState}
                                        </div>
                                    )}
                                </div>
                            </li>
                            <li
                                className="cursor-pointe relative" id="leftMenuHomeIcon"
                                onMouseEnter={() => handleMouseEnter(2)} // Tooltip görünür yapılıyor
                                onMouseLeave={() => handleMouseLeave(2)}
                            >
                                <div className="py-2 px-3">
                                    <div className="group relative flex justify-center rounded text-[#7F7F7F]">
                                        <Link to="/home">
                                            <HomeIcon
                                                className={`size-5 text-gray-500 rounded  hover:font-normal   ${themeMode === "dark"
                                                    ? " hover:text-[rgba(255,_255,_255,_0.8)]"
                                                    : "hover:text-black"
                                                    }`}
                                                onClick={() => {
                                                    // dispatch(setLeftMenuContent("Surveys"));
                                                    if (window.innerWidth < 1024 && leftMenuExpanded) {
                                                        handleToggleWidth()

                                                    }
                                                    dispatch(updateTabStates(topMenuTabs.activeTab, 'leftMenuContent', 'Surveys'));
                                                    // dispatch(setHomeSelectedTab("Surveys"));
                                                    dispatch(updateTabStates(topMenuTabs.activeTab, 'homeSelectedTab', 'Surveys'));
                                                    dispatch(updateTabPath(topMenuTabs.activeTab, 'Home', `/home/`));

                                                }}
                                            />
                                        </Link>
                                    </div>
                                </div>
                                {visibleTooltip[2] && (
                                    <div className={`tooltip absolute right z-10 top-[20px] left-[calc(32px+0.75rem)] transform -translate-y-1/2 p-2 text-center text-xs ${themeMode === "dark" ? "text-[#FFF] bg-theme-tooltip-bg" : "text-black bg-[#efeff2]"} border border-theme-popup-divider rounded shadow-theme-popup-shadow select-none flex items-center`}>
                                        Home
                                    </div>
                                )}
                            </li>
                        </ul>
                    </SidebarHeader>
                    <SidebarBody
                        className={`pt-0 border-b-0 border-t-0  relative ${themeMode === "dark" ? "bg-[#14141f] " : "bg-[#fbfbfc] "
                            }`}
                    >
                        <ul >
                            <li
                                id="leftMenuHomeDirect"
                                onMouseEnter={() => handleMouseEnter(3)} // Tooltip görünür yapılıyor
                                onMouseLeave={() => handleMouseLeave(3)}
                                className={`mb-5 border-t pt-4 cursor-pointer relative overflow-visible ${themeMode === "dark"
                                    ? "  border-solid border-white-opacity-11"
                                    : "border-solid border-black-opacity-10"
                                    }`}
                            >
                                <Link to="/home">
                                    <div
                                        className={` flex justify-center rounded text-[#7F7F7F]  hover:font-normal ${themeMode === "dark"
                                            ? " hover:text-[rgba(255,_255,_255,_0.8)]"
                                            : "hover:text-black"
                                            }`}
                                        onClick={() => {

                                            dispatch(updateTabStates(topMenuTabs.activeTab, 'leftMenuContent', 'Surveys'));
                                            // dispatch(setHomeSelectedTab("Surveys"));
                                            dispatch(updateTabStates(topMenuTabs.activeTab, 'homeSelectedTab', 'Surveys'));
                                            dispatch(updateTabPath(topMenuTabs.activeTab, 'Home', `/home/`));
                                        }}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            className="size-5 "
                                            strokeWidth="1.5"
                                            stroke="currentColor"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"
                                            />
                                        </svg>
                                    </div>
                                </Link>
                                {visibleTooltip[3] && (
                                    <div className={`tooltip absolute right z-[10000] top-[27px] left-[calc(32px+0.75rem)] transform -translate-y-1/2 p-2 text-center text-xs ${themeMode === "dark" ? "text-[#FFF] bg-theme-tooltip-bg" : "text-black bg-[#efeff2]"} border border-theme-popup-divider rounded shadow-theme-popup-shadow select-none flex items-center`}>
                                        Surveys
                                    </div>
                                )}
                            </li>
                        </ul>
                        <ul id="leftMenuSurveyCreationShortcuts">
                            <li
                                className="mb-5 cursor-pointer relative" id="leftMenuCff"
                                onMouseEnter={() => handleMouseEnter(4)} // Tooltip görünür yapılıyor
                                onMouseLeave={() => handleMouseLeave(4)}
                                onClick={() => { directionPage("create-from-file"); }}
                            >
                                <a
                                    href="#"
                                    className={`group  flex justify-center rounded text-[#7F7F7F] hover:font-normal  ${themeMode === "dark"
                                        ? " hover:text-[rgba(255,_255,_255,_0.8)]"
                                        : "hover:text-black"
                                        }`}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        className="size-5 "
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                    >
                                        <rect
                                            x="3"
                                            y="3"
                                            width="18"
                                            height="18"
                                            rx="2"
                                            ry="2"
                                            stroke="currentColor"
                                        />
                                        <line x1="9" y1="9" x2="15" y2="15" />
                                        <line x1="15" y1="9" x2="9" y2="15" />
                                        <path d="M12 18v3" />
                                        <path d="M9 20h6" />
                                    </svg>
                                </a>
                                {visibleTooltip[4] && (
                                    <div className={`tooltip absolute right z-[10000] top-[10px] w-[7rem] left-[calc(32px+0.75rem)] transform -translate-y-1/2 p-2 text-center text-xs ${themeMode === "dark" ? "text-[#FFF] bg-theme-tooltip-bg" : "text-black bg-[#efeff2]"} border border-theme-popup-divider rounded shadow-theme-popup-shadow select-none flex items-center`}>
                                        Create From File
                                    </div>
                                )}
                            </li>

                            <li className="mb-5 cursor-pointer relative" id="leftMenuCfs">
                                <a
                                    href="#"
                                    onMouseEnter={() => handleMouseEnter(5)} // Tooltip görünür yapılıyor
                                    onMouseLeave={() => handleMouseLeave(5)}
                                    onClick={() => { openNewSurveyDialog() }}
                                    className={`group relative flex justify-center rounded text-[#7F7F7F]  hover:font-normal   ${themeMode === "dark"
                                        ? " hover:text-[rgba(255,_255,_255,_0.8)]"
                                        : "hover:text-black"
                                        }`}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        className="size-5 "
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                    >
                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                        <polyline points="14 2 14 8 20 8" />
                                        <line x1="12" y1="13" x2="12" y2="17" />
                                        <line x1="10" y1="15" x2="14" y2="15" />
                                    </svg>

                                    {visibleTooltip[5] && (
                                        <div className={`tooltip absolute  right z-[10000] w-[8rem] top-[10px] left-[calc(32px+0.75rem)] transform -translate-y-1/2 p-2 text-center text-xs ${themeMode === "dark" ? "text-[#FFF] bg-theme-tooltip-bg" : "text-black bg-[#efeff2]"} border border-theme-popup-divider rounded shadow-theme-popup-shadow select-none flex items-center`}>
                                            Create From Scratch
                                        </div>
                                    )}
                                </a>
                            </li>
                            <li
                                className="mb-5 cursor-pointer relative" id="leftMenuQrobot"
                                onMouseEnter={() => handleMouseEnter(6)} // Tooltip görünür yapılıyor
                                onMouseLeave={() => handleMouseLeave(6)}
                                onClick={() => { directionPage("q-robot") }}
                            >
                                <a
                                    href="#"
                                    className={`group relative flex justify-center rounded  text-[#7F7F7F] hover:font-normal  ${themeMode === "dark"
                                        ? "hover:text-[rgba(255,_255,_255,_0.8)]"
                                        : "hover:text-black"
                                        }`}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        className="size-5 "
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                    >
                                        <rect x="7" y="7" width="10" height="10" rx="2" />
                                        <circle cx="9" cy="10" r="1" />
                                        <circle cx="15" cy="10" r="1" />
                                        <line x1="10" y1="14" x2="14" y2="14" />
                                        <line x1="12" y1="4" x2="12" y2="7" />
                                        <circle cx="12" cy="3" r="1" />
                                        <line x1="19" y1="12" x2="23" y2="12" />
                                        <line x1="21" y1="10" x2="21" y2="14" />
                                    </svg>

                                    {visibleTooltip[6] && (
                                        <div className={`tooltip absolute  right z-[10000] w-[8.5rem] top-[10px] left-[calc(32px+0.75rem)] transform -translate-y-1/2 p-2 text-center text-xs ${themeMode === "dark" ? "text-[#FFF] bg-theme-tooltip-bg" : "text-black bg-[#efeff2]"} border border-theme-popup-divider rounded shadow-theme-popup-shadow select-none flex items-center`}>
                                            Create From Q-Robot
                                        </div>
                                    )}
                                </a>
                            </li>
                            <li
                                className="mb-5 cursor-pointer relative" id="leftMenuBenchmarked"
                                onMouseEnter={() => handleMouseEnter(7)} // Tooltip görünür yapılıyor
                                onMouseLeave={() => handleMouseLeave(7)}
                                onClick={() => { directionPage("benchmarked") }}
                            >
                                <a
                                    href="#"
                                    className={`group relative flex justify-center rounded  text-[#7F7F7F] hover:font-normal  ${themeMode === "dark"
                                        ? "hover:text-[rgba(255,_255,_255,_0.8)]"
                                        : "hover:text-black"
                                        }`}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        className="size-5 "
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"
                                        />
                                    </svg>

                                    {visibleTooltip[7] && (
                                        <div className={`tooltip absolute  right z-[10000] w-[8.5rem] top-[10px] left-[calc(32px+0.75rem)] transform -translate-y-1/2 p-2 text-center text-xs ${themeMode === "dark" ? "text-[#FFF] bg-theme-tooltip-bg" : "text-black bg-[#efeff2]"} border border-theme-popup-divider rounded shadow-theme-popup-shadow select-none flex items-center`}>
                                            Benchmarked
                                        </div>
                                    )}
                                </a>
                            </li>
                        </ul>
                    </SidebarBody>
                    <SidebarFooter
                        className={` border-t-0 sticky bottom-0   ${themeMode === "dark" ? "bg-[#14141f] " : "bg-[#fbfbfc]  "
                            }`}
                            id="leftMenuFooter"
                    >
                        <div className="flex justify-center flex-col">
                            <div
                                // onMouseEnter={() => handleMouseEnter(7)} // Tooltip görünür yapılıyor
                                // onMouseLeave={() => handleMouseLeave(7)}
                                className={`cursor-pointer group relative flex justify-center  text-gray-500 hover:font-normal   pt-4  border-t ${themeMode === "dark"
                                    ? "hover:text-[rgba(255,_255,_255,_0.8)]  border-solid border-white-opacity-11"
                                    : "hover:text-black border-solid border-black-opacity-10"
                                    }`}
                            >
                                {/* <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    className="size-6"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                                    />
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                    />
                                </svg>

                                {visibleTooltip[7] && (
                                    <div className="tooltip absolute right z-[10000] top-[25px] left-[calc(32px+0.75rem)] transform -translate-y-1/2 p-2 text-center text-xs text-[#FFF] bg-theme-tooltip-bg border border-theme-popup-divider rounded shadow-theme-popup-shadow select-none flex items-center">
                                        Settings
                                    </div>
                                )} */}
                            </div>
                            <div
                                onClick={toggleNotificationDropdown}
                                id="leftMenuNotifications"
                                onMouseEnter={() => handleMouseEnter(9)} // Tooltip görünür yapılıyor
                                onMouseLeave={() => handleMouseLeave(9)}
                                className={`py-2 cursor-pointer relative ${themeMode === "dark"
                                    ? "border-solid border-white-opacity-11"
                                    : "border-solid border-black-opacity-10"
                                    }`}
                            >
                                <div
                                    className={`flex justify-center rounded text-[#7F7F7F] hover:font-normal ${themeMode === "dark"
                                        ? "hover:text-[rgba(255,_255,_255,_0.8)]"
                                        : "hover:text-black"
                                        }`}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="size-6"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
                                        />
                                    </svg>

                                    {notifications.filter((notification) => !notification.is_read)
                                        .length > 0 && (
                                            <span className="absolute top-0 right-0 inline-block w-4 h-4 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center">
                                                {
                                                    notifications.filter(
                                                        (notification) => !notification.is_read
                                                    ).length
                                                }
                                            </span>
                                        )}
                                </div>

                                {visibleTooltip[9] && (
                                    <div className={`tooltip absolute right z-[10000] top-[20px] left-[calc(32px+0.75rem)] transform -translate-y-1/2 p-2 text-center text-xs ${themeMode === "dark" ? "text-[#FFF] bg-theme-tooltip-bg" : "text-black bg-[#efeff2]"} border border-theme-popup-divider rounded shadow-theme-popup-shadow select-none flex items-center`}>
                                        Notifications
                                    </div>
                                )}
                            </div>
                            <div
                                id="leftMenuSignOut"
                                className=" py-2  cursor-pointer flex flex-col w-[2rem]"
                                onClick={toggleDropdown}
                            >
                                <div className="relative ">
                                    <button className="  bg-[rgb(76,166,238)] text-[#fff] border-[1px] border-[#205CD2] border rounded-[20%] w-[2rem] relative flex justify-center items-center min-w-0 min-h-0 shrink-0 aspect-[1] pointer-events-none">
                                        <div className="  text-[1.375rem] font-medium tracking-[-0.05em]">
                                            {user.name.charAt(0).toUpperCase()}{user.family_name.charAt(0).toUpperCase()}
                                        </div>
                                    </button>
                                    <div
                                        className={`absolute right-0 bottom-0 w-[0.81rem] h-[0.81rem] bg-[#49a26b] rounded-[50%] border-2 ${themeMode === "dark" ? "border-black" : "border-white"
                                            }  `}
                                    ></div>
                                </div>

                                {/* Dropdown Menu */}
                                {dropdownOpen && (
                                    <div ref={signoutModalRef} className="absolute flex flex-col bottom-[2.75rem] left-[5rem] max-w-[42rem] max-h-[calc(-5.5rem+100vh)] min-w-0 min-h-0  z-[999999] origin-center ">
                                        <div
                                            className={`flex flex-col w-auto min-h-0 min-w-0 max-w-[30rem]  border border-solid  rounded-lg shadow-theme-popup-shadow select-none ${themeMode === "dark"
                                                ? "bg-theme-popup-color border-theme-popup-divider"
                                                : "bg-[#FFFFFF] border-black-09"
                                                }`}
                                        >
                                            <ul className="px-2 py-2">
                                                <li
                                                    className={`py-2 cursor-pointer   border-b border-b-[1px]  ${themeMode === "dark"
                                                        ? " border-theme-popup-divider  hover:bg-[#333240]"
                                                        : " border-black-09  hover:bg-[#EBEBEB]"
                                                        }`}
                                                >
                                                    <div className="flex flex-row ">
                                                        <button className="  bg-[rgb(76,166,238)] text-[#fff] border-[#205CD2] border rounded-[20%] w-[2.5rem] relative flex justify-center items-center min-w-0 min-h-0 shrink-0 aspect-[1] pointer-events-none">
                                                            <div className="  text-[1.375rem] font-medium tracking-[-0.05em]">
                                                                {user.name.charAt(0).toUpperCase()}{user.family_name.charAt(0).toUpperCase()}
                                                            </div>
                                                        </button>
                                                        <div className="ml-2 flex flex-col">
                                                            <div
                                                                className={`  font-bold  whitespace-nowrap break-all overflow-hidden text-ellipsis min-w-0  ${themeMode === "dark"
                                                                    ? "text-[#FFF]"
                                                                    : "text-[#000]"
                                                                    }`}
                                                            >  {user.name.charAt(0).toUpperCase() + user.name.slice(1)} {user.family_name.charAt(0).toUpperCase() + user.family_name.slice(1)}
                                                            </div>
                                                            <div
                                                                className={`  text-sm whitespace-nowrap break-all overflow-hidden text-ellipsis min-w-0 text-xs ${themeMode === "dark"
                                                                    ? "text-whiteTransparent"
                                                                    : "text-theme-dark-color"
                                                                    } `}
                                                            >
                                                                {user.email}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                {/* <li
                                                    className={`px-4 py-2 cursor-pointer flex items-center space-x-2  border-b  border-b-[1px]  ${themeMode === "dark"
                                                        ? " border-theme-popup-divider  hover:bg-[#333240]"
                                                        : " border-black-09  hover:bg-[#EBEBEB]"
                                                        }`}
                                                    title="Settings"
                                                >
                                                    <div>
                                                        <button className="group  flex w-full justify-center items-center rounded-lg py-[0.625rem] px-[0.5rem] hover:text-gray-700">
                                                            <div
                                                                className={`mr-[0.5rem] ${themeMode === "dark"
                                                                    ? "text-whiteTransparent"
                                                                    : "text-black-06"
                                                                    }`}
                                                            >
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    className="size-5 opacity-75"
                                                                    fill="none"
                                                                    viewBox="0 0 24 24"
                                                                    stroke="currentColor"
                                                                    strokeWidth="2"
                                                                >
                                                                    <path
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                                                                    />
                                                                    <path
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                                                    />
                                                                </svg>
                                                            </div>
                                                            <span
                                                                className={` px-2 py-1.5  pr-4 text-sm  whitespace-nowrap break-all overflow-hidden text-ellipsis min-w-0 pr-4 flex-grow  ${themeMode === "dark"
                                                                    ? "text-[#FFF]"
                                                                    : "text-[#000]"
                                                                    }`}
                                                            >
                                                                Settings
                                                            </span>
                                                        </button>
                                                    </div>
                                                </li> */}
                                                <li
                                                    className={`px-4 py-2 cursor-pointer flex items-center space-x-2 ${themeMode === "dark"
                                                        ? "hover:bg-[#333240]"
                                                        : " hover:bg-[#EBEBEB]"
                                                        }`}
                                                    title="Sign out"
                                                >
                                                    <form action="#">
                                                        <button
                                                            type="button"
                                                            onClick={() => setLogOutAllowMenuOpen(true)}
                                                            className="group relative flex w-full justify-center items-center rounded-lg px-2 py-1.5 text-sm text-gray-500  hover:text-gray-700"
                                                        >
                                                            <div
                                                                className={`mr-[0.5rem] ${themeMode === "dark"
                                                                    ? "text-whiteTransparent"
                                                                    : "text-black-06"
                                                                    }`}
                                                            >
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    className="size-5 opacity-75"
                                                                    fill="none"
                                                                    viewBox="0 0 24 24"
                                                                    stroke="currentColor"
                                                                    strokeWidth="2"
                                                                >
                                                                    <path
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                                                                    />
                                                                </svg>
                                                            </div>
                                                            <span
                                                                className={` px-2 py-1.5  pr-4 text-sm  whitespace-nowrap break-all overflow-hidden text-ellipsis min-w-0 pr-4 flex-grow  ${themeMode === "dark"
                                                                    ? "text-[#FFF]"
                                                                    : "text-[#000]"
                                                                    }`}
                                                            >
                                                                Sign Out
                                                            </span>
                                                        </button>
                                                    </form>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                )}
                                {notificationDropdownOpen && (
                                    <div ref={notificationModalRef} className="fixed flex flex-col bottom-[2.75rem] left-[5rem] max-w-[42rem] max-h-[calc(-5.5rem+100vh)] min-w-0 min-h-0 bg-transparent z-[10000] origin-center opacity-100 ">
                                        <div
                                            className={`w-80 border rounded-lg shadow-md p-4 ${themeMode === "dark"
                                                ? "bg-[#2a2939] border-gray-700"
                                                : "bg-white border-gray-300"
                                                }`}
                                        >
                                            <div className="flex justify-between items-center mb-4">
                                                <h3
                                                    className={`text-lg font-semibold ${themeMode === "dark" ? "text-white" : "text-black"}`}
                                                >
                                                    Notifications
                                                </h3>
                                                {notifications.length > 0 && (
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            markAllAsRead()
                                                        }}
                                                        className="text-sm text-blue-500 hover:underline"
                                                    >
                                                        Mark all as read
                                                    </button>
                                                )}
                                            </div>
                                            {notifications.length > 0 ? (
                                                <ul className="space-y-1 max-h-60 overflow-y-auto">
                                                    {notifications.map((notification) => (
                                                        <li
                                                            key={notification.id}
                                                            onClick={(e) => {
                                                                e.stopPropagation()
                                                                markAsRead(notification.id)
                                                            }}
                                                            className={`p-3 py-1 mr-1 rounded-md flex items-start gap-3 transition-all duration-300 ${notification.is_read
                                                                ? themeMode === "dark"
                                                                    ? "bg-transparent text-gray-300 hover:bg-[#333240]"
                                                                    : "bg-transparent text-gray-700 hover:bg-[#EBEBEB]"
                                                                : themeMode === "dark"
                                                                    ? "border-l-4 border-[#4d7ff5] text-white hover:bg-[#333240]"
                                                                    : "border-l-4 border-[#4d7ff5] text-black hover:bg-[#EBEBEB]"
                                                                }`}
                                                        >
                                                            <div>
                                                                <p
                                                                    className={`text-sm font-medium ${notification.is_read
                                                                        ? themeMode === "dark"
                                                                            ? "text-gray-300"
                                                                            : "text-gray-500"
                                                                        : themeMode === "dark"
                                                                            ? "text-white"
                                                                            : "text-black"
                                                                        }`}
                                                                >
                                                                    {notification.message}
                                                                </p>
                                                                <small
                                                                    className={`text-xs ${notification.is_read
                                                                        ? themeMode === "dark"
                                                                            ? "text-gray-500"
                                                                            : "text-gray-400"
                                                                        : themeMode === "dark"
                                                                            ? "text-blue-200"
                                                                            : "text-blue-500"
                                                                        }`}
                                                                >
                                                                    {notification.time}
                                                                </small>
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <p
                                                    className={`text-sm ${themeMode === "dark" ? "text-gray-400" : "text-gray-600"}`}
                                                >
                                                    No notifications
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </SidebarFooter>
                </Sidebar>
                <div
                    ref={menuRef}
                    className={`flex h-screen justify-between border-r border-l overflow-visible overflow-x-visible  scrollbar-thin scrollbar-thumb-rounded scrollbar-thumb-gray-500  ${themeMode === "dark" ? " bg-[#14141f] border-white/5" : " bg-[#fbfbfc] "
                        } ${leftMenuExpanded ? "block" : "hidden"}`}
                    style={{ width: `${width}px` }}
                >
                    <div className="w-screen">
                        {leftMenuContent === "Surveys" && (
                            <LeftMenuSurveys expanded={leftMenuExpanded} getLeftMenuExpandActionFromChild={getLeftMenuExpandActionFromChild} />
                        )}
                        <ul className="space-y-4  flex flex-col">
                            {leftMenuContent === "Design" && (
                                <LeftMenuDesign />
                            )}
                            {leftMenuContent === "Collect" && (
                                <LeftMenuCollect expanded={leftMenuExpanded} getLeftMenuExpandActionFromChild={getLeftMenuExpandActionFromChild} />
                            )}
                            {leftMenuContent === "Results" && (
                                <LeftMenuResults />
                            )}
                            {leftMenuContent === "Insight" && (
                                <LeftMenuInsight expanded={leftMenuExpanded} getLeftMenuExpandActionFromChild={getLeftMenuExpandActionFromChild} />
                            )}
                        </ul>
                    </div>
                </div>

                <div
                    className="absolute top-0 right-0 h-full w-1 bg-white-600 cursor-col-resize"
                    onMouseDown={handleMouseDown}
                />
            </div>
            <Dialog
                open={logOutAllowMenuOpen}
                onClose={setLogOutAllowMenuOpen}
                className="relative z-10"
            >
                <DialogBackdrop
                    transition
                    className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${themeMode === "dark"
                                ? "bg-[#2a2939] border-white-09"
                                : "bg-[#FFFFFF] border-black-09 "
                                } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                        >
                            <div>
                                <div className="mt-0 text-start sm:mt-0">
                                    <DialogTitle
                                        as="h3"
                                        className={`text-base font-semibold ${themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                                            }`}
                                    >
                                        Sign Out
                                    </DialogTitle>
                                    <div className="mt-1">
                                        <p
                                            className={`text-sm ${themeMode === "dark" ? "text-white-8" : "text-black-8"
                                                }`}
                                        >
                                            Are you sure you want to Sign out
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                                <button
                                    type="button"
                                    onClick={() => handleLogout()}
                                    className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${themeMode === "dark"
                                        ? " border-white-09  "
                                        : " border-black-09 "
                                        } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                                >
                                    Yes
                                </button>
                                <button
                                    type="button"
                                    data-autofocus
                                    onClick={() => setLogOutAllowMenuOpen(false)}
                                    className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid ${themeMode === "dark"
                                        ? "bg-white-02 border-white-09 text-white-8 hover:text-white hover:bg-white-04"
                                        : "bg-black-02 border-black-09 text-black-8 hover:text-black hover:bg-black-04"
                                        } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-1 sm:mt-0`}
                                >
                                    No
                                </button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
            <Dialog open={newSurveyDialog} onClose={setNewSurveyDialog} className="relative z-10">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0 w-auto">
                        <DialogPanel
                            transition
                            className={`relative md:w-[500px] sm:max-w-2xl w-auto transform rounded-lg bottom-[100px] ${themeMode === "dark" ? "bg-[#2a2939]" : "bg-white"
                                } px-4 pb-4 text-left shadow-xl transition-all ...`}
                        >
                            <div className="pb-6 px-6 flex flex-col h-full items-stretch justify-start">
                                <div className="text-center sm:mt-5">
                                    <DialogTitle
                                        as="h3"
                                        className={`text-base font-semibold flex align-center ${themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                                            }`}
                                    >
                                        New Survey
                                    </DialogTitle>
                                    <Field className="mt-2 flex align-center">
                                        <div className="flex flex-col flex-grow">
                                            <div className="inline-flex flex-col items-start min-w-0 w-full">
                                                <div className="font-normal text-[1.25rem] w-full min-w-0 min-h-0 flex items-center flex-nowrap">
                                                    <input
                                                        type="text"
                                                        value={newSurveyName}
                                                        onChange={(e) => setNewSurveyName(e.target.value)}
                                                        placeholder="Survey Name"
                                                        className={`w-full m-0 p-0 min-w-0 border-none rounded-[2px] font-inherit bg-transparent outline-none ${themeMode === "dark"
                                                            ? "text-white"
                                                            : "text-[#000]"
                                                            }`}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </Field>
                                </div>
                            </div>
                            <div
                                className={`flex flex-row-reverse justify-between items-center border-t border-white/9 overflow-hidden flex-shrink-0 ltr p-4 h-[4.25rem] rounded-b-md ${themeMode === "dark" ? "border-white-09" : "border-black-09"
                                    }`}
                            >
                                <div
                                    className={`text-[0.75rem] grid grid-flow-col auto-cols-max justify-start items-center gap-3 flex-shrink-0`}
                                >
                                    <button
                                        className={`min-w-[5rem] flex-shrink-0 px-3 py-2 flex justify-center align-center border-solid border rounded-[0.375rem] h-[2.25rem] ${"text-[#fff] border-white-09 cursor-pointer hover:bg-[#3575DE] bg-[#205DC2]"
                                            }`}
                                        type="submit"
                                        onClick={()=>createNewSurvey()}
                                    >
                                        <span
                                            className={`whitespace-nowrap break-all text-ellipsis overflow-hidden min-w-0 pointer-events-none ${"text-[#fff]"
                                                }`}
                                        >
                                            Create
                                        </span>
                                    </button>
                                </div>
                                <div className="buttons-group small-gap text-sm"></div>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default LeftMenu;
